import React from 'react';
import { BiBadgeCheck } from 'react-icons/bi';

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Frontend</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">HTML</h3>
                        <span className="skills__level">Advanced</span>
                    </div>
                </div>

                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">CSS</h3>
                        <span className="skills__level">Advanced</span>
                    </div>
                </div>

                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">React</h3>
                        <span className="skills__level">Advanced</span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">React Native</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">NextJs</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data">
                    <BiBadgeCheck className="skills__icon" />

                    <div>
                        <h3 className="skills__name">TailwindCss</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
};

export default Frontend;